import { includes, find } from 'lodash';

const GENERIC_DOMAIN = 'wms?service=WMS&version=1.1.0&request=GetMap&layers=';
const URL_CONSTANTS = [
  'geoserver/',
  '/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=',
  '&outputFormat=csv'
];

/**
 * Transforms a WMS url into a CSV.
 *
 * @param {string} url - The URL of the WMS.
 * @returns {string} The new url.
 * @throws {Error} If something goes wrong.
 */
const getCSVURLFromWMS = url => {
  let adaptedUrl = url;
  if (includes(url, GENERIC_DOMAIN)) {
    const split = url.split('/');
    const stringContainer = find(split, item => includes(item, GENERIC_DOMAIN));
    const colomPosition = stringContainer.search(':');
    const layersPosition = stringContainer.search('layers=');
    const mainName = stringContainer.slice(layersPosition + 7, colomPosition);
    const layerName = stringContainer.slice(colomPosition + 1, stringContainer.length);
    const domainPosition = url.search(URL_CONSTANTS[0]);
    const domain = url.slice(0, domainPosition);
    adaptedUrl += `${domain}${URL_CONSTANTS[0]}${mainName}${URL_CONSTANTS[1]}${mainName}:${layerName}${URL_CONSTANTS[2]}`;
  }
  return adaptedUrl;
};

export default getCSVURLFromWMS;
